import { IPackageListingAppState } from "..";
import PackageApi from "../../common/package-api";
import { processPackageRequest, processPackageRequestError, receivePerformancePricing, receivePackagePricing } from "./package-listing.actions";
import { IPerformancePricing } from "../../custom/classes/production";
import { filterMap } from "../../helpers/map-helpers";
import cartItem from "../../components/cart/cart-item";
import cartItems from "../../components/cart/cart-items";

export function processPackage(redirectToSmartSeat: boolean) {
    return (dispatch, getState: () => IPackageListingAppState) => {
        const state = getState();

        dispatch(processPackageRequest());
        var priceTypes = [];

        Array.from(state.packageListing.priceTypeQuantity.keys()).forEach(pt => {
            var quantity = state.packageListing.priceTypeQuantity.get(pt);
            var i;
            for (i = 0; i < quantity; i++) {
                priceTypes.push(pt);
            }

        });

        if (state.packageListingSettings.isFixed) {

            const superPackagesInCart = state.packageListing.subPackagesInCart;
            var regularFixedPackages = state.packageListing.cartItems;

            if (superPackagesInCart.size > 0) {
                // has super packages in cart

                regularFixedPackages = state.packageListing.cartItems
                    .filter(cartItem => Array.from(superPackagesInCart.keys()).indexOf(cartItem.cartItemId) < 0)

                superPackagesInCart.forEach((subPackageIds, packageId) => {
                    let subPackageZones = {};

                    subPackageIds.forEach(subPackageId => {
                        subPackageZones[subPackageId] = state.packageListing.cartItems.filter(cartItem => cartItem.cartItemId == subPackageId);
                    })

                    PackageApi.processSuperPackage(packageId,
                        subPackageZones,
                        priceTypes,
                        state.packageListing.orderNotes,
                        state.packageListingSettings.configId
                    ).then(apiResult => {
                        if (apiResult.success && apiResult.redirectUrl != null) {
                            window.location = apiResult.redirectUrl;
                        } else {
                            dispatch(processPackageRequestError(apiResult.errorMessages));
                        }
                    }).catch(error => {
                        //dispatch(errorPromoCodeApply(error));
                    });
                })
            } else {
                regularFixedPackages.forEach((cartItem) => {

                    PackageApi.processFixedPackage(cartItem.cartItemId,
                        cartItem.selectedZoneId,
                        cartItem.selectedAlternateItem?.cartItemId,
                        cartItem.selectedAlternateItem?.selectedZoneId,
                        priceTypes,
                        state.packageListing.orderNotes,
                        state.packageListingSettings.configId,
                        state.packageListing.seatingPreferences,
                        redirectToSmartSeat
                    ).then(apiResult => {
                        if (apiResult.success && apiResult.redirectUrl != null) {
                            window.location = apiResult.redirectUrl;
                        } else {
                            dispatch(processPackageRequestError(apiResult.errorMessages));
                        }
                    }).catch(error => {
                        //dispatch(errorPromoCodeApply(error));
                    });
                });
            }
        } else {
            let performanceZones = {};
            if (state.packageListing.packageDetail.useUnseatedReservation) {
                var zoneId = state.packageListing.cartItems[state.packageListing.cartItems.length - 1].selectedZoneId;
                state.packageListing.cartItems.forEach(cartItem => {
                    performanceZones[cartItem.cartItemId] = zoneId;
                })
            }
            else {
                state.packageListing.cartItems.forEach(cartItem => {
                    performanceZones[cartItem.cartItemId] = cartItem.selectedZoneId;
                });
            }
            

            return PackageApi.processFlexPackage(state.packageListing.packageDetail.id, performanceZones,
                priceTypes, state.packageListing.packageDetail.useUnseatedReservation,
                state.packageListing.orderNotes,
                state.packageListingSettings.configId,
                redirectToSmartSeat
            ).then(apiResult => {
                if (apiResult.success && apiResult.redirectUrl != null) {
                    window.location = apiResult.redirectUrl;
                } else {
                    dispatch(processPackageRequestError(apiResult.errorMessages));
                }
            }).catch(error => {
                //dispatch(errorPromoCodeApply(error));
            });
        }

    }
}

export function getFlexPackagePricingForPerfs(performanceIds: string, quantity: number, priceTypeId: number) {
    return (dispatch, getState: () => IPackageListingAppState) => {
        return PackageApi.getFlexPackagePricingForPerfs(performanceIds, quantity, priceTypeId).then(apiResult => {
            dispatch(receivePerformancePricing(apiResult));
        }).catch(error => {

        })
    }
}

export function getPerformancePricing(performanceId: number) {
    return (dispatch, getState: () => IPackageListingAppState) => {

        //dispatch(processPackageRequest());

        return PackageApi.getPerformancePricing(performanceId).then(apiResult => {

            dispatch(receivePerformancePricing(apiResult));
        }).catch(error => {
            //dispatch(errorPromoCodeApply(error));
        });
    }
}

export function getPackagePricing(packageId: number) {
    return (dispatch, getState: () => IPackageListingAppState) => {

        return PackageApi.getPackagePricing(packageId).then(apiResult => {

            dispatch(receivePackagePricing(apiResult));
        }).catch(error => {
        });
    }
}